module.exports = __webpack_public_path__ + "static/media/Group7878.3dd0b2b5.svg";